const renderOptions = {
    block: {
        normal: ({ children }) => <p>{children}</p>,
    },
    marks: {
        link: ({ children, value }) => {
            const href = value?.href;
            if (!href) return children;

            return (
                <a href={href} target="_blank" rel="noopener noreferrer">
                    {children}
                </a>
            );
        },
    },
    hardBreak: () => <br />,
};

export default renderOptions;
